import React from 'react';
import { normalTheme, ThemeProvider } from 'themes';
import detector from './utils/detector';
import GlobalStyleSheet from './assets/globalStyle/globalStyle';
import Routes from './routes';
import { BrowserRouter } from 'react-router-dom';
import useRnEventListener from './hooks/useRnEventListner';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import 'antd/dist/antd.css';

const queryClient = new QueryClient();

function App() {
  useRnEventListener();
  const clientEnv = detector();

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={normalTheme}>
        <BrowserRouter>
          <Routes />
        </BrowserRouter>
        <GlobalStyleSheet
          isIOS={clientEnv === 'ios'}
          isMobile={clientEnv !== 'pc'}
        />
        <ReactQueryDevtools initialIsOpen={false} />
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
